__turbopack_context__.v({
  "page": "page-module-scss-module__UvChgq__page",
});
